// extracted by css-extract-rspack-plugin
export default {"content":"SearchWrapper_content__9IElG","fab":"SearchWrapper_fab__cgH1t"};